<template>
  <div class="user-panel">
    <div class="user-info">
      <img class="user-image" :src="profile.pictureUrl" alt="" />
      <div class="user-name">{{ profile.name }}</div>
    </div>

    <dx-context-menu
      v-if="menuMode === 'context'"
      target=".user-button"
      :items="menuItems"
      :width="170"
      :position="menuPositionConfig"
      show-event="dxclick"
      css-class="user-menu"
    />

    <dx-list
      v-if="menuMode === 'list'"
      class="dx-toolbar-menu-action"
      :items="menuItems"
    />
  </div>
</template>

<script>
import DxContextMenu from 'devextreme-vue/context-menu'
import DxList from 'devextreme-vue/list'
import { mapState } from 'vuex'

export default {
  components: {
    DxContextMenu,
    DxList,
  },
  props: {
    menuMode: { type: String, required: true },
    menuItems: { type: Array, required: true },
  },
  data() {
    return {
      menuPositionConfig: {
        my: 'top center',
        at: 'bottom center',
      },
    }
  },
  computed: {
    ...mapState('user', ['profile']),
  },
}
</script>

<style lang="scss">
@import '../themes/generated/variables.base.scss';

.user-info {
  display: flex;
  align-items: center;

  .dx-toolbar-menu-section & {
    padding: 10px 6px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .user-image {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }

  .user-name {
    font-size: 14px;
    color: $base-text-color;
    margin: 0 9px;
  }
}

.user-panel {
  .dx-list-item .dx-icon {
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.87);
    margin-right: 16px;
  }

  .dx-rtl .dx-list-item .dx-icon {
    margin-right: 0;
    margin-left: 16px;
  }
}

.dx-context-menu.user-menu.dx-menu-base {
  &.dx-rtl {
    .dx-submenu .dx-menu-items-container .dx-icon {
      margin-left: 16px;
    }
  }

  .dx-submenu .dx-menu-items-container .dx-icon {
    margin-right: 16px;
  }

  .dx-menu-item .dx-menu-item-content {
    padding: 3px 15px 4px;
  }
}

.dx-theme-generic .user-menu .dx-menu-item-content .dx-menu-item-text {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
